import Dexie, { type Table } from 'dexie';

// TECH-002/PWA-002..009: IndexedDB (via Dexie) für Offline-First.
// `cache` hält zuletzt bekannte Serverantworten für den Offline-Start,
// `outbox` hält durchgeführte, aber noch nicht bestätigte Änderungen in
// einer dauerhaften, geordneten Warteschlange (PWA-005).
export interface CacheEntry {
  key: string; // z. B. "list:123" oder "lists:user:abc"
  data: unknown;
  updatedAt: number;
}

export interface OutboxEntry {
  id: string; // dient zugleich als Idempotency-Key (SYNC-001/003)
  method: 'POST' | 'PATCH' | 'PUT' | 'DELETE';
  path: string;
  body?: unknown;
  createdAt: number;
  entityType: string;
  meta?: unknown; // nur für die lokale Anzeige (z. B. Produktname), wird nicht an den Server gesendet
  status: 'pending' | 'failed';
  lastError?: string;
  attempts: number;
}

class AppDatabase extends Dexie {
  cache!: Table<CacheEntry, string>;
  outbox!: Table<OutboxEntry, string>;

  constructor() {
    super('shoppinglist-pwa');
    this.version(1).stores({
      cache: 'key, updatedAt',
      outbox: 'id, createdAt, status',
    });
  }
}

export const db = new AppDatabase();

export async function readCache<T>(key: string): Promise<T | undefined> {
  const entry = await db.cache.get(key);
  return entry?.data as T | undefined;
}

export async function writeCache(key: string, data: unknown): Promise<void> {
  await db.cache.put({ key, data, updatedAt: Date.now() });
}
